import { useFilterState } from "./ducks/filter/hooks/filterState";
import { useGetQuerysQuery } from "@/services/it/updates/query-update";
import { Load } from "components/load";
import { columns } from "./components/table/columns";
import { DataTable } from "./components/table/data-table";
import { Meta } from "@/@types/paginated";
import { ContentContainer, PageLayout, PageTitle } from "components/layout";

const UpdatesControl = () => {
  const filterState = useFilterState();
  const { filters } = filterState || { filters: {} };

  const {
    data: querys,
    isLoading,
    isFetching,
  } = useGetQuerysQuery({
    search: filters.search,
    orderBy: JSON.stringify("desc"),
    perPage: filters.meta.perPage || 10,
    meta: {
      page: filters?.meta?.page || 1,
    },
  });

  if (isLoading) return <Load />;
  const { data, meta } = querys || { data: [], meta: {} };
  return (
    <PageLayout>
      <PageTitle
        title="Lista de Aprovação"
        description="Faça controle das querys operadas dentro do banco de dados."
      />
      <ContentContainer>
        <DataTable
          data={data as any}
          columns={columns}
          meta={meta as Meta}
          isLoading={isFetching}
        />
      </ContentContainer>
    </PageLayout>
  );
};

export default UpdatesControl;
